import React, { useState } from "react";
import styled from "styled-components";
import OTPinput from "./OTPinput";
import { Colors, TextFont } from "../../config";
import { Error } from "../../config/StyledComponents";

const hideIcon = require("../../assets/images/Hide.png");
const showIcon = require("../../assets/images/Show.png");

const OTPfield = ({
  label,
  uniqueName, //required text
  getEnteredOTP,
  otpCount = 4,
  placeholder = "",
  hiddenNeeded,
  showHideOTP,
  setShowHideOTP,
  autoFocus,
  errorText,
}) => {
  const [inputValue, setInputValue] = useState(new Array(otpCount).fill(""));

  const handleChange = (e) => {
    e.preventDefault();
    const { value, name } = e.target;
    if (!isNaN(Number(value))) {
      const fieldIndex = name.split("-")[2];
      let fieldIntIndex = parseInt(fieldIndex);
      if (fieldIntIndex < otpCount) {
        const nextfield = document.querySelector(
          `input[name=${uniqueName}-field-${fieldIntIndex + 1}]`
        );
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
      let newArr = inputValue;
      newArr[fieldIntIndex] = value;
      setInputValue(newArr);
      getEnteredOTP(newArr.join(""));
    }
  };

  const handleFocus = (e) => {
    const target = e.target;
    setTimeout(() => target.select(), 0);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text/plain");
    if (pasted.length === otpCount && !isNaN(Number(pasted))) {
      setInputValue(pasted.split(""));
      getEnteredOTP(pasted);
    }
  };

  return (
    <OTDfieldLabelContainer>
      {label && (
        <OTPlabel>
          <TextFont fontColor={Colors.coolGrey} fontWeight="400">
            {label}
          </TextFont>
        </OTPlabel>
      )}
      <OTDfieldWrapper>
        {Array(otpCount)
          .fill()
          .map((_, index) => {
            return (
              <OTPinput
                key={index}
                type={hiddenNeeded && !showHideOTP ? "password" : "number"}
                placeholder={placeholder}
                value={inputValue[index]}
                name={`${uniqueName}-field-${index}`}
                onChange={handleChange}
                onFocus={handleFocus}
                onPaste={handlePaste}
                autoFocus={autoFocus && index === 0}
                errorText={errorText}
              />
            );
          })}
        {hiddenNeeded && (
          <HideOrShowImage
            src={showHideOTP ? hideIcon : showIcon}
            alt={showHideOTP ? "hide_icon" : "show_icon"}
            onClick={() => setShowHideOTP(!showHideOTP)}
          />
        )}
      </OTDfieldWrapper>
      {errorText && <Error>{errorText}</Error>}
    </OTDfieldLabelContainer>
  );
};

export default OTPfield;

const OTDfieldLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const OTPlabel = styled.div`
  margin: 0rem 0rem 0.75rem 1rem;
  @media only screen and (max-width: 500px) {
    margin-left: 0.5rem;
  }
`;
const OTDfieldWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`;
const HideOrShowImage = styled.img`
  cursor: pointer;
  margin-left: 2rem;
  @media only screen and (max-width: 500px) {
    margin-left: 0;
  }
`;
